import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { twMerge } from "tailwind-merge";
import type { ReactNode } from "react";
import { Button } from "../Button";
import { Icon } from "../Icon";

export const Dropdown = ({ children }: { children: ReactNode }) => {
  return <Menu>{children}</Menu>;
};

export const DropdownButton = ({
  children,
  disabled,
}: {
  children?: ReactNode;
  disabled?: boolean;
}) => {
  return (
    <MenuButton disabled={disabled}>
      {children ?? (
        <Button color={"secondary"} disabled={disabled}>
          <Icon icon={"DOTS_VERTICAL"} />
        </Button>
      )}
    </MenuButton>
  );
};

export const DropdownButtonSlim = ({
  children,
  className,
}: {
  children?: ReactNode;
  className?: string;
}) => {
  return (
    <MenuButton
      className={twMerge(
        "w-fit px-3 py-2 text-sm font-medium",
        "bg-white hover:bg-zinc-100 dark:bg-zinc-800 dark:hover:bg-zinc-700",
        "border border-solid border-zinc-300 dark:border-zinc-700",
        "cursor-pointer",
        "relative flex items-center justify-center gap-2 rounded-lg text-center leading-5 font-semibold tracking-wide whitespace-nowrap not-italic transition-colors first-of-type:ml-0 last-of-type:mr-0 motion-reduce:transition-none",
        "w-fit px-3 py-2",
        className,
      )}
    >
      {children ?? (
        <Button color={"secondary"}>
          <Icon icon={"DOTS_VERTICAL"} />
        </Button>
      )}
    </MenuButton>
  );
};

export const DropdownItems = ({ children }: { children?: ReactNode }) => {
  return (
    <MenuItems
      anchor={"bottom end"}
      modal={false}
      className={
        "rounded-lg border border-solid border-neutral-200 bg-white shadow-md [--anchor-gap:4px] dark:border-zinc-800 dark:bg-zinc-900"
      }
    >
      {children}
    </MenuItems>
  );
};

export const DropdownItem = ({
  onClick,
  children,
  className,
  disabled,
}: {
  onClick?: () => void;
  children: string;
  className?: string;
  disabled?: boolean;
}) => {
  return (
    <MenuItem
      as={"div"}
      className={twMerge(
        "cursor-pointer p-3 hover:bg-neutral-50 dark:text-zinc-300 dark:hover:bg-zinc-800",
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </MenuItem>
  );
};

export const DropdownHeadingItem = ({
  children,
  className,
}: {
  children: string;
  className?: string;
}) => {
  return (
    <MenuItem
      as={"div"}
      className={twMerge(
        "border-b border-zinc-200 bg-zinc-100 p-3 font-semibold text-zinc-700 dark:border-zinc-800 dark:bg-zinc-950 dark:text-zinc-400",
        className,
      )}
    >
      {children}
    </MenuItem>
  );
};
